import axios from '../Axios/axiosInstance.js';

export async function callKeepSessionAliveAPI(sessionToken) {
  try {
    const response = await axios.post(
      "/v3/sso/KeepSessionAlive",
      {
        sessionToken: sessionToken,
      },
      {
        headers: {
          "Content-Type": "application/json",
          "ClientCode": process.env.REACT_APP_CLIENT_CODE || "",
          "PartnerCode": process.env.REACT_APP_PARTNER_CODE || "",
          "access-token": sessionStorage.getItem("accessToken") || "",
        },
      }
    );

    const data = response.data;

    if (data.responseCode === "200" && data.response?.tokenTimeOutExpiryInSeconds) {
      return data.response.tokenTimeOutExpiryInSeconds.toString();
    }

    return null;
  } catch (error) {
    console.error("Keep Session Alive API error:", error);
    return null;
  }
}

export function startKeepSessionAlive(partnerSessionToken) {
  const callKeepAlive = async () => {
    const sessionToken = partnerSessionToken || sessionStorage.getItem("partnerSessionToken");
    let result = null;
    if(sessionToken) {
      result = await callKeepSessionAliveAPI(sessionToken);
    }
    
    if (result === null) {
      return;
    }
  };

  // Call immediately after login
  callKeepAlive();

  // Set up interval to call every 4 minutes (240000 ms)
  return setInterval(callKeepAlive, 240000);
}
